import React from "react";
import { useEffect } from "react";
import {
  getSellerProfile,
  sellerIsBlock,
  getSellerProduct,
  getSellerWallet,
} from "../../../store/seller/seller.action";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getDefaultCurrency } from "../../../store/currency/currency.action";

const Shop = (props) => {
  const { sellerProfile, sellerWallet } = useSelector((state) => state.seller);
  const { defaultCurrency } = useSelector((state) => state.currency);
  const { state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSellerProfile(state));
    dispatch(getSellerWallet(state));
    dispatch(getDefaultCurrency())
  }, [dispatch]);
  return (
    <>
      <div className="row mt-4">
        <div className="col-xl-4 col-md-6 col-12 pb-3 pe-3">
          <div className="card" style={{ borderRadius: "5px" }}>
            <div className="card-body">
              <div className="boxCenter p-3">
                <img
                  src={sellerProfile?.image}
                  width={90}
                  height={90}
                  style={{ borderRadius: "55%" }}
                  alt=""
                  onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/dummy.png";
                      }}
                />
              </div>
              <div className="">
                <div className="fw-bold boxCenter">
                  {sellerProfile?.firstName ? sellerProfile?.firstName : " "}{" "}
                  {sellerProfile?.lastName ? sellerProfile?.lastName : " "}
                </div>

              </div>

              <table className="custom-info-table mt-4">
                <tbody>
                  {[
                    { label: "Email", value: sellerProfile?.email },
                    { label: "Business Name", value: sellerProfile?.businessName },
                    { label: "Business Tag", value: sellerProfile?.businessTag },
                    { label: "Mobile Number", value: sellerProfile?.mobileNumber },
                    {
                      label: "Address",
                      value:
                        (sellerProfile?.address?.address ?? "") +
                        " " +
                        (sellerProfile?.address?.landMark ?? ""),
                    },
                    { label: "Bank Name", value: sellerProfile?.bankDetails?.bankName },
                    { label: "Account Number", value: sellerProfile?.bankDetails?.accountNumber },
                    { label: "Bank Business Name", value: sellerProfile?.bankDetails?.bankBusinessName },
                    { label: "IFSC Code", value: sellerProfile?.bankDetails?.IFSCCode },
                    { label: "Branch Name", value: sellerProfile?.bankDetails?.branchName },
                  ].map((row, idx) => (
                    <tr key={idx}>
                      <td className="label-cell">{row.label}</td>
                      <td className="value-cell">{row.value || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
        <div className="col-xl-8 col-md-6 col-12 pb-3 ps-2 ">
          <div className="custom-wallet-card ">
            <div className="header">
              <i className="bi bi-wallet2 header-icon"></i>
              <h5>
                {sellerProfile?.firstName ?? ""} {sellerProfile?.lastName ?? ""}'s Wallet
              </h5>
            </div>
            <div className="row g-4 pt-3">
              {[
                {
                  title: "Pending Amount",
                  icon: "bi-hourglass-split",
                  value: sellerWallet?.pendingAmount ?? 0,
                },
                {
                  title: "Pending Withdrawable",
                  icon: "bi-cash-coin",
                  value: sellerWallet?.pendingWithdrawbleAmount ?? 0,
                },
                {
                  title: "Commission Given",
                  icon: "bi-percent",
                  value: sellerWallet?.totalCommissionGiven ?? 0,
                },
                {
                  title: "Total Earned",
                  icon: "bi-piggy-bank",
                  value: sellerWallet?.earningAmount ?? 0,
                },
                {
                  title: "Withdrawable Requested",
                  icon: "bi-clock-history",
                  value: sellerWallet?.pendingWithdrawbleRequestedAmount ?? 0,
                },
              ].map((item, idx) => (
                <div className="col-md-6" key={idx}>
                  <div className="wallet-glass-card">
                    <div className="icon-bubble">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                    <div>
                      <p className="wallet-title">{item.title}</p>
                      <h3 className="wallet-amount">
                        {defaultCurrency?.symbol} {item.value}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getSellerProfile,
  sellerIsBlock,
  getSellerProduct,
  getSellerWallet,
})(Shop);

{
  /* <div className="col-xl-8 col-lg-8 col-md-6 col-12">
<div className="row">
  <div className="col-xl-6 col-lg-12 col-md-12 col-12 ps-3 pt-3">
    <div className="card text-center py-2">
      <div className="card-body py-xl-4 py-3">
        <div className="row">
          <div className="col-3">
            <div className="right-icon">
              <img
                src={require("../../../../assets/images/pendingAmount.png")}
                width={70}
                alt=""
                srcset=""
              />
            </div>
          </div>
          <div className="col-9 boxCenter">
            <div className="left-info ">
              <div>
                <span className="fs-3 text-dark fw-bold me-2">
                  $ {sellerWallet?.pendingAmount}
                </span>
              </div>
              <span className="text-muted">
                Pending Amount
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-6 col-lg-12 col-md-12 col-12 ps-3 pt-3">
    <div className="card text-center py-2">
      <div className="card-body py-xl-4 py-3">
        <div className="row">
          <div className="col-3">
            <div className="right-icon">
              <img
                src={require("../../../../assets/images/comission.png")}
                width={70}
                alt=""
                srcset=""
              />
            </div>
          </div>
          <div className="col-9 boxCenter">
            <div className="left-info ">
              <div>
                <span className="fs-3 text-dark fw-bold me-2">
                  ${sellerWallet?.totalCommissionGiven}
                </span>
              </div>
              <span className="text-muted">
                Total Comission Given
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-6 col-lg-12 col-md-12 col-12 ps-3 pt-3">
    <div className="card text-center py-2">
      <div className="card-body py-xl-4 py-3">
        <div className="row">
          <div className="col-3">
            <div className="right-icon">
              <img
                src={require("../../../../assets/images/totalEarned.png")}
                width={70}
                alt=""
                srcset=""
              />
            </div>
          </div>
          <div className="col-9 boxCenter">
            <div className="left-info ">
              <div>
                <span className="fs-3 text-dark fw-bold me-2">
                  $ {sellerWallet?.EarningAmount}
                </span>
              </div>
              <span className="text-muted">Total Earned</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-6 col-lg-12 col-md-12 col-12 ps-3 pt-3">
    <div className="card text-center py-2">
      <div className="card-body py-xl-4 py-3">
        <div className="row">
          <div className="col-3">
            <div className="right-icon">
              <img
                src={require("../../../../assets/images/pendingrequest.png")}
                width={70}
                alt=""
                srcset=""
              />
            </div>
          </div>
          <div className="col-9 boxCenter">
            <div className="left-info">
              <div>
                <span className="fs-3 text-dark fw-bold me-2">
                  ${" "}
                  {
                    sellerWallet?.pendingWithdrawalRequestedAmount
                  }
                </span>
              </div>
              <span className="text-muted">
                Pending Withdrawable Requested Amount
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div> */
}
